export default __webpack_public_path__ + "static/media/icon-dropdown-arrow-down.93eac9e4.svg";